import BaseModel from '../BaseModel';

export default class Edge extends BaseModel {
  constructor(connectionType, modelType, data = {}) {
    super(null, {
      ...data,
      __typename: `${connectionType.name}Edge`,
    });
    this.node = new modelType(data.node);
    this.cursor = data.cursor;
  }
}
